import { useEffect, useState } from 'react';
import { recommendationsApi } from '../services/api';
import {
  DEFAULT_RECOMMENDATION_ITEMS,
  mergeItems,
  type RecommendationItem,
} from '../utils/recommendationCatalog';

/**
 * Katalog zaleceń per-lokal (migr. 059) dla formularza lokalu w adminie. Od razu stałe z kodu,
 * potem API (pozycje z zakładki „Zalecenia"); błąd API zostawia stałe — formularz musi działać
 * i bez katalogu z serwera (lustro mobilnego useRecommendationItems, bez cache).
 */
export function useRecommendationItems(enabled: boolean): RecommendationItem[] {
  const [items, setItems] = useState<RecommendationItem[]>(DEFAULT_RECOMMENDATION_ITEMS);

  useEffect(() => {
    if (!enabled) return undefined;
    let cancelled = false;
    (async () => {
      try {
        const fresh = await recommendationsApi.getApartmentItems();
        if (!cancelled) setItems(mergeItems(fresh.items));
      } catch (error) {
        // Brak katalogu z API to nie błąd formularza — zostają pozycje wbudowane.
        console.warn('Apartment recommendation items: using built-in defaults:', error);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return items;
}
